import {
  ChangeEventHandler,
  DetailedHTMLProps,
  FormEventHandler,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
  useState,
} from 'react'
import './Input.less'
import ValidationMessage from '../ValidationMessage/ValidationMessage'
import getValidationMessage from './Validation/getValidationMessage'

interface CustomProps {
  fieldName?: string // the name that will be used in validation error messages
  forwardedRef?: ForwardedRef<HTMLInputElement | null>
}

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> &
  CustomProps

const _Input = ({
  onChange: _onChange,
  onInvalid: _onInvalid,
  className,
  fieldName = 'value',
  forwardedRef,
  ...props
}: InputProps): JSX.Element => {
  const [invalidMessage, setInvalidMessage] = useState<string | null>(null)

  const onInvalid: FormEventHandler<HTMLInputElement> = (event) => {
    _onInvalid && _onInvalid(event)
    const { currentTarget } = event
    setInvalidMessage(getValidationMessage(currentTarget, fieldName))
    event.preventDefault()
  }
  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    _onChange && _onChange(event)
    setInvalidMessage(null)
  }

  return (
    <ValidationMessage className='hb-input' invalidMessage={invalidMessage}>
      <input
        {...props}
        onInvalid={onInvalid}
        onChange={onChange}
        ref={forwardedRef}
        className={`${className ? `${className} ` : ''}`}
      />
    </ValidationMessage>
  )
}

const Input = forwardRef<HTMLInputElement | null, InputProps>(function CustomInput(props, ref) {
  return <_Input forwardedRef={ref} {...props} />
})

export default Input
